import { render, staticRenderFns } from "./FeatureDetail.vue?vue&type=template&id=494a8cff&scoped=true&"
import script from "./FeatureDetail.vue?vue&type=script&lang=js&"
export * from "./FeatureDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeatureDetail.vue?vue&type=style&index=0&id=494a8cff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a8cff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
